import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className="foot">
            <h4>Stay with us for more update</h4>
            
            <h6>Copyright © Glamour World</h6>
            <h6>Contact With us</h6>
            <h6>☎ +9111100</h6>
            <h6>✉ : glamourworld@gmail.com</h6>
           
            
        </div>
    );
};

export default Footer;